import { connect, bindActionCreators } from '../dependencies';

import Menu from '../components/Menu';
import { menuIsFetchingSelector } from '../services/selectors';

const mapStateToProps = (state, props) => ({
    isLoading: menuIsFetchingSelector(state, props),
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Menu);
